import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TermsofuseComponent } from'./termsofuse/termsofuse.component';
import { PrivacypolicyComponent} from './privacypolicy/privacypolicy.component';
import { FaqComponent } from './faq/faq.component';
const routes: Routes = [
  {
    path: '',
    component: TermsofuseComponent,
    children: [
      { path: 'termsofuse', component: TermsofuseComponent },
    ]
  },
  {
    path: '',
    component: PrivacypolicyComponent,
    children: [
      { path: 'privacypolicy', component: PrivacypolicyComponent },
    ]
  },
  {
    path: '',
    component: FaqComponent,
    children: [
      { path: 'faq', component: FaqComponent },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OtherLinksRoutingModule { }
